import { render } from "./TemperatureHistory.vue?vue&type=template&id=91ec007a&scoped=true"
import script from "./TemperatureHistory.vue?vue&type=script&lang=js"
export * from "./TemperatureHistory.vue?vue&type=script&lang=js"

import "./TemperatureHistory.vue?vue&type=style&index=0&id=91ec007a&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ec007a"]])

export default __exports__